// extracted by mini-css-extract-plugin
export var link = "SocialMediaIcon-module--link--8db4c";
export var icon = "SocialMediaIcon-module--icon--8c76c";